import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import Table from "../../../components/table/Table";
import Icon from "../../../components/icon/Icon";
import OggettiUtili from "../../../utils/OggettiUtili";
import Spinner from "../../../components/spinner/Spinner";
import SessioneUtente from "../../../sessionManager/SessioneUtente";
import DizionariService from "../../../services/DizionariService";
import Ruoli from "../../../utils/Ruoli.json";
import Utils from "../../../utils/Utils";
import ToasterSingleton from "../../../singleton/ToasterSingleton";
import SegnalazioniHIVServices from "../../../services/SegnalazioniHIVServices";

class Home extends Component {
    state = {
        rows: [],
        totalElements: 0,
        cols: [],
        loading: false,
        page: 0,
        totalPages: 0,
        size: 10,
        notifiche: [],
    };

    constructor(props) {
        super(props);
        this.buildParams = this.buildParams.bind(this);
        this.controllaUlss = this.controllaUlss.bind(this);
        this.changePageTable = this.changePageTable.bind(this);
        this.changePaginationTable = this.changePaginationTable.bind(this);
    }

    cols = [
        {
            key: "progressivoRegistro",
            name: "Tables.HomeHiv.id",
            sortDirection: "none",
            tipo: "link",
            path: "/formHIV",
            nomeParametro: "progressivoRegistro",
            state: { currentState: true },
        },
        {
            key: "codiceIndividualePaziente",
            name: "Tables.HomeHiv.paziente",
            sortDirection: "none",
        },
        {
            key: "codiceStruttura",
            name: "Tables.HomeHiv.ulssSegnalazione",
            sortDirection: "none",
        },
        {
            key: "dataSegnalazione",
            name: "Tables.HomeHiv.dataSegnalazione",
            sortDirection: "none",
            tipo: "data",
        },
    ];

    componentDidMount() {
        ToasterSingleton.instance().sottoscrizione(this);
        let segnalazioniRequestParam = this.buildParams();
        this.getSegnalazioniHIV(
            Utils.removeEmptyValueFromObject(segnalazioniRequestParam)
        );
        DizionariService.getProvince();
        DizionariService.getNazioni();
        DizionariService.getAulss();
        DizionariService.getSiglaProvince();
        DizionariService.getAulssPerComuni();
        DizionariService.getComuni();
        DizionariService.getComuniPerAulss();
        this.props.setStatePadre({ hiv: true });
    }

    getSegnalazioniHIV(segnalazioniRequestParam) {
        this.setState({ loading: true });
        SegnalazioniHIVServices.getSegnalazioniHIV(segnalazioniRequestParam)
            .then((data) => {
                let res = SegnalazioniHIVServices.mapGetSegnalazioniHIV(data);
                let newState = {
                    rows: Utils.idSegnalazioneUlss(res),
                    loading: false,
                    totalPages: data.data.totalPages,
                    totalElements: data.data.totalElements,
                };

                if (
                    segnalazioniRequestParam.size &&
                    segnalazioniRequestParam.size !== this.state.size
                ) {
                    newState["size"] = segnalazioniRequestParam.size;
                }
                if (
                    (segnalazioniRequestParam.page ||
                        segnalazioniRequestParam.page === 0) &&
                    segnalazioniRequestParam.page !== this.state.page
                ) {
                    newState["page"] = segnalazioniRequestParam.page;
                }

                this.setState(newState);
            })
            .catch(() => {
                let newState = {
                    rows: [],
                    totalElements: 0,
                    loading: false,
                    page: 0,
                };
                newState["size"] = this.state.size;

                if (
                    (segnalazioniRequestParam.page ||
                        segnalazioniRequestParam.page === 0) &&
                    segnalazioniRequestParam.page !== this.state.page
                ) {
                    newState["page"] = segnalazioniRequestParam.page;
                }
                this.setState(newState);
            });
    }

    controllaUlss() {
        if (
            SessioneUtente.getInstance() &&
            OggettiUtili.UlssImg[SessioneUtente.getInstance().ulss]
        ) {
            return OggettiUtili.UlssImg[SessioneUtente.getInstance().ulss]
                .descrizione;
        } else {
            return false;
        }
    }

    changePageTable(sort, direction, page, size) {
        let params = this.buildParams(sort, direction, page, size);
        if (size != null) {
            if (size !== this.state.size) {
                params.size = this.state.size;
            } else {
                params.size = size;
            }
        }
        this.getSegnalazioniHIV(params);
    }

    changePaginationTable(sort, direction, page, size) {
        let params = this.buildParams(sort, direction, page, size);
        if (size != null) params.size = size;
        this.getSegnalazioniHIV(params);
    }

    buildParams(sort, direction, page, size) {
        return Utils.removeEmptyValueFromObject({
            ulss:
                SessioneUtente.getInstance().ruoliUtente ===
                    Ruoli.Operatore_HIV.descrizione ||
                SessioneUtente.getInstance().ruoliUtente ===
                    Ruoli.Operatore_Sisp_HIV.descrizione
                    ? SessioneUtente.getInstance().ulss
                    : null,
            home: true,
            page: page,
            order: direction,
            sort: sort,
            size: size,
        });
    }

    render() {
        const { t } = this.props;

        return (
            <div className={"container"}>
                {ToasterSingleton.instance().renderToaster()}
                <div style={{ display: "flex", justifyContent: "center" }}>
                    {this.controllaUlss() ? (
                        <Icon path={this.controllaUlss()} />
                    ) : (
                        <div style={{ marginTop: "5rem" }} />
                    )}
                </div>
                {this.state.loading ? (
                    <div>
                        <Spinner />
                    </div>
                ) : (
                    <div />
                )}
                <h6>{t("Home.titoloTabella")}</h6>
                <div>
                    <Table
                        cols={this.cols}
                        rows={this.state.rows}
                        emptyMsg={t("Tables.HomeHiv.noSegnalazioni")}
                        lengthEditable={true}
                        totalElements={this.state.totalElements}
                        bigTable={true}
                        homePage={true}
                        totalPages={this.state.totalPages}
                        page={this.state.page}
                        changePage={this.changePageTable}
                        changePagination={this.changePaginationTable}
                    />
                </div>
            </div>
        );
    }
}

export default withTranslation("common")(Home);
